import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ISucursalesClienteDTO, SucursalesCliente } from '@ciptech/classes';
import { ApiResponse } from '../dto';
import { handleApiError } from '../utils';

@Injectable()
export class WsClienteService {
  private endpoint = `/api/WsCliente`;

  constructor(private http: HttpClient) { }

  creditoCliente(id, ctx?): Observable<any> {
    // const headers = new HttpHeaders({ context: 'credit-form' });
    return this.http.get(`${this.endpoint}/balance-gestion/${id}`, { headers: { context: ctx || 'body' } })
      .pipe(
        map((res: any) => {
          if (res) {
            res.DOCUMENTOS_PENDIENTES = res.DOCUMENTOS_PENDIENTES.sort((a, b) => a.FECHA_EMISION > b.FECHA_EMISION ? 1 : -1);
            res.TOTAL_DEUDA = res.DOCUMENTOS_PENDIENTES.reduce((sum, current) => sum + current.BALANCE, 0);
            res.PORCENTAJE = res.TOTAL_DEUDA * 100 / res.MONTO_CREDITO;
            const date = new Date(new Date().setHours(0, 0, 0, 0));
            res.DOCUMENTOS_VENCIDOS = res.DOCUMENTOS_PENDIENTES.filter(x => x.FECHA_VCTO && new Date(x.FECHA_VCTO).getTime() - date.getTime() < 0);
            res.TOTAL_VENCIDOS = res.DOCUMENTOS_VENCIDOS.reduce((sum, current) => sum + current.BALANCE, 0);
          }

          return res;
        })
      );
  }

  contactos(id: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.endpoint}/contactos/${id}`, { headers: { context: '.load-contact' } })
      .pipe(map(res => {
        return res.sort((a, b) => a.Nombre > b.Nombre ? 1 : -1);
      }),
      catchError(this.handleError)
      );
  }

  buscar(tipoDoc: 'DNI' | 'RUC', numDoc: string) {
    return this.http.get<any[]>(`${this.endpoint}/buscar?TipoDoc=${tipoDoc}&NumDoc=${numDoc}`, { headers: { context: 'body' } });
  }

  ById(id: number): Observable<any> {
    return this.http.get<any>(`${this.endpoint}/byId/${id}`, { headers: { context: '.load-cliente' } });
  }

  Sucursales(codCipsa: string): Observable<ApiResponse<SucursalesCliente[]>> {
    return this.http.get<ApiResponse<ISucursalesClienteDTO[]>>(`${this.endpoint}/sucursales/${codCipsa}`, { headers: { context: '.load-contact' } })
    .pipe(
      map(res => {
        return {
          Success: res.Success,
          Message: res.Message,
          Data: res.Success? res.Data.map(x => new SucursalesCliente(x)): []
        }
      }),
      catchError(handleApiError<SucursalesCliente[]>())
    );
  }

  handleError(error: HttpErrorResponse) {
    if (error.status === 0) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('Ocurrió un error:', error.error);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      console.error(
        `Error en servidor ${error.status}, la respuesta fue: `, error.error);
    }
    // Return an observable with a user-facing error message.
    return throwError(() => new Error('Algo malo sucedio; Por favor, inténtelo de nuevo más tarde.'));
  }

}
